var map = {
	"./basic.png": "2db9",
	"./bg.png": "3f6e",
	"./bg2.png": "89d4",
	"./bg3.png": "59f3",
	"./cpmplete.png": "a447",
	"./djq.png": "3035",
	"./djq_over.png": "a4c1",
	"./drop.png": "f655",
	"./get.png": "bce7",
	"./hb.png": "44c1",
	"./hb_over.png": "d071",
	"./money.png": "b6a1",
	"./money_over.png": "660b",
	"./noget.png": "5f5d",
	"./over_get.png": "0e87",
	"./red_bg.png": "2d02",
	"./sign1.png": "6c1b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";